<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2387.71 1681.61">
    <g>
      <g>
        <path
          d="M2219.51,1110.47,2138,1055.83l-92.3-192.73c-2.89-6.05-50.68-102.1-174.34-114.61-1-.1-2-.15-3-.15H1636.14V626.91a110.89,110.89,0,0,0-110.77-110.76H574.9a30,30,0,0,0,0,60h950.47a50.82,50.82,0,0,1,50.77,50.76v478.81l-577.66-.33h0a30,30,0,0,0,0,60l577.69.33V1294a30,30,0,0,0,60,0V808.34h230.58c37.11,4,69.16,18.5,95.28,43,20.12,18.86,29.24,37.07,29.52,37.64h0l95.85,200.16a30,30,0,0,0,10.36,12l88.31,59.17c1.93,1.34,31,22.29,41.21,67.34h-41.52a30,30,0,0,0,0,60h45v124.06a50.82,50.82,0,0,1-50.76,50.76H2058.8c-14.42-90.09-92.68-159.16-186.78-159.16s-172.36,69.07-186.78,159.16H1077.75c-14.42-90.1-92.68-159.16-186.78-159.16s-172.36,69.06-186.78,159.16H574.89a50.82,50.82,0,0,1-50.76-50.76V1257.62a30,30,0,0,0-60,0v154.06a110.89,110.89,0,0,0,110.61,110.76H704.19c14.42,90.1,92.68,159.17,186.78,159.17s172.36-69.07,186.78-159.17h607.49c14.42,90.1,92.68,159.17,186.78,159.17s172.36-69.07,186.78-159.17h121.37a110.88,110.88,0,0,0,110.6-110.76V1260C2290.77,1160.14,2224.17,1113.6,2219.51,1110.47ZM891,1621.61c-71.21,0-129.15-57.93-129.17-129.14v0c0-71.21,58-129.14,129.17-129.14a129.31,129.31,0,0,1,129.16,129.16C1020.13,1563.66,962.19,1621.61,891,1621.61Zm981.05,0a129.32,129.32,0,0,1-129.17-129.17c0-71.22,58-129.16,129.17-129.16a129.17,129.17,0,0,1,0,258.33Z"
        />
        <path
          d="M1872,925.92a30,30,0,0,0,0-60,110.88,110.88,0,0,0-110.76,110.76V1055A110.89,110.89,0,0,0,1872,1165.74h140.61a30,30,0,0,0,0-60H1872a50.82,50.82,0,0,1-50.76-50.77V976.68A50.82,50.82,0,0,1,1872,925.92Z"
        />
        <path
          d="M222.78,766.84h66.84a30,30,0,0,0,0-60H222.78a30,30,0,1,0,0,60Z"
        />
        <path
          d="M347.46,576.15H414.3a30,30,0,1,0,0-60H347.46a30,30,0,1,0,0,60Z"
        />
        <path
          d="M874.86,736.84a30,30,0,0,0-30-30H454.13a30,30,0,0,0,0,60H844.86A30,30,0,0,0,874.86,736.84Z"
        />
        <path
          d="M306.78,948a30,30,0,0,0-30-30H225.37a30,30,0,1,0,0,60h51.41A30,30,0,0,0,306.78,948Z"
        />
        <path d="M86.55,918H30a30,30,0,0,0,0,60H86.55a30,30,0,0,0,0-60Z" />
        <path d="M425.87,918a30,30,0,1,0,0,60h239a30,30,0,1,0,0-60Z" />
        <path
          d="M644.8,1135.74a30,30,0,0,0-30-30H311.47a30,30,0,0,0,0,60H614.8A30,30,0,0,0,644.8,1135.74Z"
        />
        <path d="M820.45,1105.74h-36a30,30,0,0,0,0,60h36a30,30,0,0,0,0-60Z" />
        <path
          d="M2346.76,318.18A520.58,520.58,0,0,0,1866.73,0c-109.5,0-214.29,33.59-303,97.14a522.36,522.36,0,0,0-187.54,248,30,30,0,1,0,56.48,20.25C1498.12,182.74,1672.56,60,1866.73,60c254.18,0,461,206.8,461,461,0,104.92-34.34,203.77-99.29,285.84a30,30,0,0,0,47,37.24,521.67,521.67,0,0,0,71.29-525.88Z"
        />
        <path
          d="M1867.13,164.52a30,30,0,0,0-30,30V437.06A89.12,89.12,0,1,0,1951.05,551h204.77a30,30,0,0,0,0-60H1951.05a89.57,89.57,0,0,0-53.92-53.92V194.52A30,30,0,0,0,1867.13,164.52Zm0,385.59A29.13,29.13,0,1,1,1896.25,521,29.16,29.16,0,0,1,1867.13,550.11Z"
        />
        <path
          d="M891,1442.25a50.19,50.19,0,1,0,50.19,50.19A50.25,50.25,0,0,0,891,1442.25Z"
        />
        <path
          d="M1872,1442.25a50.19,50.19,0,1,0,50.19,50.19A50.25,50.25,0,0,0,1872,1442.25Z"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
</script>

<style></style>
